import React, { useState, useEffect, useContext, lazy, Suspense, useRef } from 'react';
import { Cookies } from '../index.js';
import axios from 'axios';
import { alert_error, alert_success } from '../AppContext';
import Login_google from './login_google_main';
const App = () => {
    const [disabledbutton, setdisabledbutton] = useState(true);
    const [nutxuly, setnutxuly] = useState(0);
    const [buttonTextjop, setbuttonTextjop] = useState("Vui lòng tiếp tục bằng google 👌");
    return (
        <>
            <div className="max-w-2xl px-1 py-1  mt-3 mx-auto rounded-lg shadow-xl">
                <form className="add-form" >
                    <div className="form-control">
                        <div style={{ textAlign: "center" }} className="mt-1 mb-3">
                            <div className="max-w-lg mx-auto">
                                <Login_google disabledbutton={disabledbutton} setdisabledbutton={setdisabledbutton}
                                    nutxuly={nutxuly} setnutxuly={setnutxuly}           
                                    buttonTextjop={buttonTextjop} setbuttonTextjop={setbuttonTextjop}              
                                />
                            </div>
                        </div>
                        <button disabled={disabledbutton}
                            className='flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
                            <div className='flex items-center justify-between flex-1'>
                                {nutxuly == 1 && (
                                    <div className="spinner-border" role="status">

                                    </div>
                                )}
                                <span className='text-lg font-medium text-white'>
                                    {buttonTextjop} </span>
                                    <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                            </div>
                        </button>
                    </div>
                </form>
            </div>
        </>
    );

};


export default App;